/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import { Button } from '@components';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { DrawerContext } from './Drawer';

/**
 * DrawerClose component that renders a close button.
 *
 * @component DrawerClose
 * @param {Object} props - The properties for the DrawerClose component.
 * @param {string} [props.className] - Optional additional CSS classes to apply to the DrawerClose container.
 * @param {Object} [restProps] - Additional properties to be passed to the DrawerClose container.
 * @returns {ReactElement} The rendered DrawerClose component.
 * @example
 * <DrawerClose />
 */
export default function DrawerClose({ className, ...restProps }) {
  const { setIsOpen } = useContext(
    DrawerContext,
    'Drawer.Close must be a child of Drawer.'
  );

  return (
    <div className="sticky top-0 z-10 bg-white px-2 py-2 ">
      <div className="flex justify-end">
        <Button
          variant="tertiary"
          onClick={() => setIsOpen(false)}
          className={mergeClasses('', className)}
          aria-label={t`Close Modal`}
          {...restProps}
        >
          <Button.Icon>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z" />
            </svg>
          </Button.Icon>
        </Button>
      </div>
    </div>
  );
}

DrawerClose.propTypes = {
  className: PropTypes.string
};

DrawerClose.defaultProps = {
  className: ''
};
